import styled from 'styled-components';
import { brandColor, colors } from '../../config';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 43, 57, 0.55);
`;

export const Panel = styled.div`
  position: relative;
  width: 100%;
  max-width: 32rem;
  margin: 1.5rem auto;
  padding: 2rem 1.5rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18);
  text-align: center;

  @media (min-width: 640px) {
    padding: 2.5rem;
  }
`;

export const Title = styled.h2`
  margin: 0 0 0.75rem;
  font-family: Mulish, sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${brandColor};
`;

export const Description = styled.p`
  margin: 0 auto 1.5rem;
  max-width: 28rem;
  font-size: 1rem;
  line-height: 1.5;
  color: ${colors.accentBlue};
`;

export const OtpRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin: 0 auto;
`;

export const OtpInput = styled.input`
  width: 2.75rem;
  height: 3.25rem;
  border: 1px solid #c5d0d6;
  border-radius: 6px;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 600;
  color: ${brandColor};
  outline: none;

  &:focus {
    border-color: ${colors.accentLink};
    box-shadow: 0 0 0 2px rgba(31, 163, 255, 0.25);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.p`
  margin: 1rem 0 0;
  color: #cc0000;
  font-size: 0.875rem;
`;

export const SecondaryText = styled.p`
  margin: 1rem 0 0;
  color: ${colors.accentBlue};
  font-size: 0.95rem;
  line-height: 1.4;
`;

export const ResendButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: ${colors.accentLink};
  font: inherit;
  text-decoration: underline;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    text-decoration: none;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1.75rem;
`;

const sharedButton = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 8.5rem;
  height: 3rem;
  padding: 0 1.25rem;
  border-radius: 0;
  font-family: Mulish, sans-serif;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;

  &[disabled] {
    opacity: 0.5;
    cursor: default;
  }
`;

export const CancelButton = styled.button`
  ${sharedButton}
  border: 2px solid ${brandColor};
  background: #fff;
  color: ${brandColor};
`;

export const SubmitButton = styled.button`
  ${sharedButton}
  position: relative;
  border: none;
  background-color: ${colors.accentYellow};
  color: ${brandColor};

  span.loading {
    opacity: 0;
  }

  .spinner {
    position: absolute;
    animation: around 3s infinite;
  }

  @keyframes around {
    100% {
      transform: rotate(0deg);
    }
    0% {
      transform: rotate(1080deg);
    }
  }
`;
